import apiSlice from "../../features/apiSlice";
import { removeEmptyKeys } from "../../utils/helper";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLanguage: builder.query({
      query: (queries) => {
        return {
          url: '/language',
          params: removeEmptyKeys(queries),
        };
      },
      providesTags:['Language']
    }),
    createLanguage: builder.mutation({
      query: (credentials) => ({
        url: "/language",
        method: "POST",
        body: credentials,
      }),
      invalidatesTags:['Language']
    }),
    updateLanguage: builder.mutation({
      query: (credentials) => ({
        url: `/language/${credentials.id}`,
        method: "PUT",
        body: credentials.body,
      }),
      invalidatesTags:['Language']
    }),
    bulkUpdateLanguage: builder.mutation({
      query: (credentials) => ({
        url: `/language/updateMany`,
        method: "POST",
        body: credentials,
      }),
      invalidatesTags:['Language']
    }),
    deleteLanguage: builder.mutation({
      query: (credentials) => ({
        url: `/language/${credentials.id}`,
        method: "DELETE",
        body: credentials.body,
      }),
      invalidatesTags:['Language']
    }),
    hardDeleteLanguage: builder.mutation({
      query: (credentials) => ({
        url: `/language/hardDelete/${credentials.id}`,
        method: "DELETE",
        body: credentials.body,
      }),
      invalidatesTags:['Language']
    }),
  }),
});

export const {
  useGetLanguageQuery,
  useCreateLanguageMutation,
  useUpdateLanguageMutation,
  useBulkUpdateLanguageMutation,
  useDeleteLanguageMutation,
  useHardDeleteLanguageMutation
} = authApiSlice;
